import type { SignInCredentials } from '@words-happen/screens';
import { loadEmailAuth } from './load-email-auth';

export interface VerificationOptions {
  /** Where the verification email's link continues to: id.<domain>/verify-email, keeping return_to. */
  continueUrl: string;
}

/** A signed-in player; an unverified one stays signed in to Firebase and is asked to verify. */
export interface SignInResult {
  verified: boolean;
}

/** Signs in with an email and password; rejects with the Firebase error when the sign-in fails. */
export type SignInWithEmail = (credentials: SignInCredentials) => Promise<SignInResult>;

/** Identity Platform email sign-in (email-auth.ts), loading the Firebase SDK on first use. */
export const signInWithEmail: SignInWithEmail = async (credentials) =>
  (await loadEmailAuth()).signInWithEmail(credentials);
